const truthy = new Set(['1', 'true', 'yes', 'on']);
const falsy = new Set(['0', 'false', 'no', 'off']);

const readBooleanFlag = (name, defaultValue = true) => {
  const raw = import.meta.env?.[name];
  if (raw === undefined || raw === null || raw === '') return defaultValue;
  const normalized = String(raw).trim().toLowerCase();
  if (truthy.has(normalized)) return true;
  if (falsy.has(normalized)) return false;
  return defaultValue;
};

export const FEATURE_FLAGS = {
  // Writer Agent is legacy-keep and hidden by default. Set VITE_FEATURE_WRITER_AGENT=true to re-enable.
  writerAgent: readBooleanFlag('VITE_FEATURE_WRITER_AGENT', false),
  toolkit: readBooleanFlag('VITE_FEATURE_TOOLKIT', false),
  blogs: readBooleanFlag('VITE_FEATURE_BLOGS', true),
  analysisHub: readBooleanFlag('VITE_FEATURE_ANALYSIS_HUB', false),
  ideas: readBooleanFlag('VITE_FEATURE_IDEAS', true),
  automations: readBooleanFlag('VITE_FEATURE_AUTOMATIONS', true),
  agentsHub: readBooleanFlag('VITE_FEATURE_AGENTS_HUB', true),
  workspace: readBooleanFlag('VITE_FEATURE_WORKSPACE', true),
  redesignPreview: readBooleanFlag('VITE_FEATURE_REDESIGN_PREVIEW', true),
  // Retired runtime branch — adapter path is now the only path in StudioPage.
  // Key kept for env-override documentation and future Studio-specific experiments.
  studioAgentSurfacePath: readBooleanFlag('VITE_FEATURE_STUDIO_AGENT_SURFACE_PATH', true),
  // Shipped product surface; explicit false remains the rollback switch.
  campaignWorkspaceMvp: readBooleanFlag('VITE_FEATURE_CAMPAIGN_WORKSPACE_MVP', true),
  // Design-review copies only. These routes must stay absent from production
  // unless a review environment opts in explicitly.
  nikiMarketingPreviews: readBooleanFlag('VITE_FEATURE_NIKI_MARKETING_PREVIEWS', false),
  nikiMarketingDashboard: readBooleanFlag('VITE_FEATURE_NIKI_MARKETING_DASHBOARD', false),
};

export const isFeatureEnabled = (flagName) => FEATURE_FLAGS[flagName] !== false;
